import { TableCell, TableHead, TableRow } from '@mui/material'
import { FormattedMessage } from 'react-intl'
import { HeadCell } from '../../../../../types'
import { useSelector } from '../../../../../store/store'
import { hasPermission } from '../../../../../utils/tools'
import { isEndCustomer } from '../../../../../constants'

const headCellsOrders: HeadCell[] = [
  {
    id: 'displayId',
    numeric: false,
    label: 'order-id',
  },
  {
    id: 'customerName',
    numeric: false,
    label: 'customer',
  },
  {
    id: 'jobName',
    numeric: false,
    label: 'job-title',
  },
  {
    id: 'place',
    numeric: false,
    label: 'place',
  },

  {
    id: 'channel',
    numeric: false,
    label: 'portal',
  },
]

const DashboardTableHeads = () => {
  const { permissions, userInfo } = useSelector((state) => state.user)
  const permission = hasPermission(permissions?.orderDetailsFields)
  const { role } = userInfo

  return (
    <TableHead>
      <TableRow>
        {headCellsOrders?.map((headCell) => {
          // Skip customer column if user is end customer
          if (headCell.id === 'customerName' && (!permission('customer') || isEndCustomer(role))) {
            return null
          }
          // Skip place column if no permission
          if (headCell.id === 'place' && !permission('place')) {
            return null
          }
          // Skip channel column if no permission
          if (headCell.id === 'channel' && !permission('channel')) {
            return null
          }
          // Skip jobName column if no permission
          if (headCell.id === 'jobName' && !permission('jobName')) {
            return null
          }

          return (
            <TableCell
              key={headCell.id}
              align="left"
              padding={headCell.disablePadding ? 'none' : 'normal'}
            >
              <FormattedMessage id={headCell.label} />
            </TableCell>
          )
        })}
        <TableCell />
      </TableRow>
    </TableHead>
  )
}

export default DashboardTableHeads
